"use client";
import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {useNeoContext} from "@/context/neo/neo.context";
import {useState} from "react";

export const BillingHistory = () => {
  const {filterContext, offset} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState<string>("");
  const DEFAULT_COLUMNS = [
    // {uid: "sno", name: "S.No"},
    {uid: "date", name: "Date"},
    {uid: "invoiceId", name: "Invoice ID"},
    {uid: "credits", name: "Credits"},
    {uid: "amount", name: "Amount"}
    // {uid: "status", name: "Status"},
    // {uid: "paymentmethod", name: "Payment Method"}
  ];
  const ALL_COLUMN_UIDS = DEFAULT_COLUMNS.map(c => c.uid);
  const baseTableConfig = {
    columns: DEFAULT_COLUMNS,
    activeColumns: ALL_COLUMN_UIDS,
    activeFilters: ["date"],
    style: {height: "h-full"},
    meta: {
      id: 4,
      title: "Transaction History",
      description: "Total",
      hasSearch: false,
      hasUpload: false,
      hasDownload: true,
      hasAdd: false,
      hasActions: false,
      hasCheckbox: false,
      hasFilter: true,
      hasFooter: true,
      hasHeader: true,
      hasPagination: true,
      hasCreate: false
    },
    url: {
      page: {},
      api: {
        get: "/api/creditsPoint/billings/history"
      }
    }
  };

  return (
    <div className="w-full bg-white">
      <NeoAGgrid table={baseTableConfig} />
    </div>
  );
};
